module.exports = __webpack_public_path__ + "fdb7eec53bed10c9d60840cc9c202f12.pdf";